import { render } from "./NotesContainer.vue?vue&type=template&id=bf095620&scoped=true"
import script from "./NotesContainer.vue?vue&type=script&lang=js"
export * from "./NotesContainer.vue?vue&type=script&lang=js"

import "./NotesContainer.vue?vue&type=style&index=0&id=bf095620&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf095620"],['__file',"src/components/NotesContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf095620"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf095620', __exports__)) {
    api.reload('bf095620', __exports__)
  }
  
  module.hot.accept("./NotesContainer.vue?vue&type=template&id=bf095620&scoped=true", () => {
    api.rerender('bf095620', render)
  })

}


export default __exports__